import React, { useEffect, useState } from 'react';
import './LabPricingStyles.css';
import { MdOutlineArrowBackIos } from "react-icons/md";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { useAlert } from 'react-alert';
import TestDetails from './TestDetails';
import PanelShow from './PanelShow';
import TestShow from './TestShow';
import GroupShow from './AddGroup/GroupShow';
import sampleList from './sampleList';
import { IoSearch } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import { FaEdit, FaPlus } from "react-icons/fa";

const LaboratoryTestPricing = (props) => {
  const [selectedCategory, setSelectedCategory] = useState("blood");
  const [selectedTest, setSelectedTest] = useState(null);
  const [selectedPanel, setSelectedPanel] = useState(null);
  const [addPanel, setAddPanel] = useState(false);
  const [addTest, setAddTest] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState(null);
  const navigate = useNavigate();
  const alert = useAlert();
  const [previousSelectedTestId, setPreviousSelectedTestId] = useState(null);
  const [previousSelectedPanelId, setPreviousSelectedPanelId] = useState(null);

  useEffect(() => {
    handleSampleData('blood');
  }, []);

  const handleSampleData = (sample) => {
    const tokenString = sessionStorage.getItem('usertoken');
    let str = tokenString.replace(/["]+/g, '');
    axios.get(`${APIURL}/api/v1/staff/lab-test/?sample=${sample}&${TZ}`, {
      headers: {
        "Authorization": 'Token ' + str
      }
    })
      .then(res => {
        if (res.status === 200) {
          if (res.data.status === 'success') {
            setData(res.data);

            if (previousSelectedTestId) {
              const updatedSelectedTest = res.data.tests.find(test => test.id === previousSelectedTestId);
              setSelectedTest(updatedSelectedTest || null);
            }
            if (previousSelectedPanelId) {
              const updatedSelectedPanel = res.data.panels.find(panel => panel.id === previousSelectedPanelId);
              setSelectedPanel(updatedSelectedPanel || null);
            }
          } else {
            alert.error(res.data.message);
            setData(null)
          }
        } else {
          alert.error('Error occurred, try again');
        }
      })
      .catch(err => {
        alert.error('Error fetching sample data');
      });
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    handleSampleData(category);
    setSelectedTest(null);
    setSelectedPanel(null);
  };

  const handleItemClick = (item, type) => {
    if (type === "test") {
      if (selectedTest !== item) {
        setSelectedTest(item);
        setPreviousSelectedTestId(item.id);
      } else {
        setSelectedTest(null);
        setPreviousSelectedTestId(null);
      }
      setPreviousSelectedPanelId(null)
      setSelectedPanel(null);
    } else if (type === "panel") {
      if (selectedPanel !== item) {
        setSelectedPanel(item);
        setPreviousSelectedPanelId(item.id);
      } else {
        setSelectedPanel(null);
        setPreviousSelectedPanelId(null);
      }
      setSelectedTest(null);
      setPreviousSelectedTestId(null);
    }
  };

  const handleSuccess = () => {
    setAddPanel(false);
    setAddTest(false);
    handleSampleData(selectedCategory);
  };

  const filteredTests = data?.tests.filter(test =>
    test.test_name.toLowerCase().includes(search.toLowerCase())
  ) || [];

  const filteredPanels = data?.panels.filter(panel =>
    panel.panel_name.toLowerCase().includes(search.toLowerCase())
  ) || [];

  return (
    <div className="lab-pricing-container">
      <div className="lab-pricing-header">
        <div>
          <button className="back-arrow" onClick={() => navigate('/data-management')}>
            <MdOutlineArrowBackIos />
          </button>
          <label className="lab-pricing-title">Laboratory tests</label>
        </div>
        <div style={{ display: "flex" }}>
          <button className='add-btn' onClick={() => { navigate('/grp-show') }}>Group</button>&nbsp;
          <button className='add-btn' onClick={() => { setAddPanel(!addPanel) }}><FaPlus /> Panel</button>&nbsp;
          <button className='add-btn' onClick={() => { setAddTest(!addTest) }}><FaPlus /> Test</button>&nbsp;
          <div className='search-input'>
            <IoSearch />
            <input
              style={{ border: "none" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search..."
            />
          </div>
        </div>
      </div>

      <div className="lab-pricing-content">
        <div className="left-side-buttons" style={{ flex: (selectedPanel || selectedTest) ? 1 : 2 }}>
          <div className="left-side-buttons-title">Samples</div>
          <div className="left-side-buttons" style={{ borderRadius: 0, border: "none" }}>
            {sampleList.map((category) => (
              <button
                key={category}
                className={`category-button ${selectedCategory === category ? "active" : ""}`}
                onClick={() => handleCategoryClick(category)}
              >
                {category.replace(/_/g, ' ')}
              </button>
            ))}
          </div>
        </div>
        <div className="test-panel-column" style={{ flex: (selectedPanel || selectedTest) ? 2 : 5 }}>
          <div className="left-side-buttons-title">
            <span>Panels</span>
          </div>
          <div className="panel-box">
            <div className="panel-widgets">
              {filteredPanels.length > 0 ? (filteredPanels.map((panel) => (
                <div
                  key={panel.id}
                  className={`panel-widget ${selectedPanel?.id === panel.id ? "active" : ""}`}
                  onClick={() => handleItemClick(panel, "panel")}
                >
                  <h3>{panel.panel_name}</h3>
                </div>))) : (
                <label style={{ color: "red" }}>No added panels!!</label>
              )
              }
            </div>
          </div>
          <div className="left-side-buttons-title" style={{ borderRadius: "0px" }}>
            <span>LabTest</span>
          </div>
          <div className="test-box">
            <div className="test-widgets">
              {filteredTests.length > 0 ? (
                filteredTests.map((test) => (
                  <div
                    key={test.id}
                    className={`test-widget ${selectedTest?.id === test.id ? "active" : ""}`}
                    onClick={() => handleItemClick(test, "test")}
                  >
                    <h3>{test.test_name}</h3>
                  </div>
                ))
              ) : (
                <label style={{ color: "red" }}>No added tests!!</label>
              )}
            </div>
          </div>
        </div>

        <div className="pricing-details" style={{ flex: (selectedPanel || selectedTest) ? 3 : 2 }}>
          <div className="left-side-buttons-title"> Test Details</div>
          {selectedTest && <TestDetails selected={"test"} selectedTest={selectedTest} data={data} handleSuccess={handleSuccess} sample={selectedCategory} />}
          {selectedPanel && <TestDetails selected={"panels"} selectedTest={selectedPanel} data={data} handleSuccess={handleSuccess} sample={selectedCategory} />}
          {addPanel && <PanelShow handleSuccess={handleSuccess} sample={selectedCategory} onClose={() => { setAddPanel(false) }} />}
          {addTest && <TestShow handleSuccess={handleSuccess} sample={selectedCategory} onClose={() => { setAddTest(false) }} />}
        </div>
      </div>
    </div>
  );
};

export default LaboratoryTestPricing;